var Icons = {
    updating: false,
    settings: false,
    update: function() {
        if (!Icons.updating) {
            Icons.updating = true;
            let container = document.getElementById('icons_data');
            let status = container.dataset.status;
            let btn = document.getElementById('btn-update-box-icons');

            if (status==="disabled") {
                container.setAttribute('data-status', 'enabled');
                container.classList.remove('icons-hidden');
                btn.innerText = 'Ocultar contenido';
            } else {
                container.setAttribute('data-status', 'disabled');
                container.classList.add('icons-hidden');
                btn.innerText = 'Mostrar contenido';
            }
            Icons.updating = false;
        } else {
            Alert.push([{type: 'danger', text: '¡Espera! Estamos procesando una petición previa tuya.', icon: 'triangle-alert'}]);
        }
    },
    set: function (icon_id) {
        if (!Icons.updating && !Icons.settings) {
            Icons.settings = true;
            Api.post('/icons/set', {id: icon_id}, function(i) {
                if (i.success) {
                    Alert.push([{
                        type: 'success',
                        text: '¡Bien! El ícono ha sido actualizado satisfactoriamente.',
                        icon: 'check'
                    }]);
                } else {
                    switch(i.error.identifier) {
                        case 'no_changes':
                            Alert.push([{type: 'danger', text: '¡Oops! El ícono seleccionado ya está colocado en tu cuenta.', icon: 'triangle-alert'}]);
                            break;
                        case 'account_doesnt_have_effect':
                            Alert.push([{type: 'danger', text: '¡Oops! Este ícono no pertenece a tu cuenta.', icon: 'triangle-alert'}]);
                            break;
                        case 'afro_is_required':
                            Alert.push([{type: 'danger', text: '¡Oops! Es necesario ser del Club Afro para colocarte un ícono.', icon: 'triangle-alert'}]);
                            break;
                    }
                }
            });
            Icons.settings = false;
        } else {
            Alert.push([{type: 'danger', text: '¡Bueno! Estamos procesando una petición tuya. Espera un momento..', icon: 'triangle-alert'}]);
        }
    }

};
